import React from 'react';

import { useTranslation } from 'hooks';
import { GuestInformation } from '.';

export default function ChangeGuestInfo({ propertyContent, guestInfoValues, editGuestInfo }) {
	const { t } = useTranslation();
	return (
		<div className="change-detail-modal">
			<div className="change-detail-modal__header">
				<div className="change-detail-modal__title">{t('Guest Information')}</div>
				<p className="change-detail-modal__copy">{t('Please confirm your attending guests')}</p>
			</div>
			<GuestInformation
				propertyContent={propertyContent}
				guestInfoValues={guestInfoValues}
				onSubmit={editGuestInfo}
			/>
		</div>
	);
}
